import {
  Flex,
  HStack,
  Icon,
  IconButton,
  Link,
  Stack,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import { SmallCloseIcon } from '@chakra-ui/icons'
import { FiPaperclip } from 'react-icons/fi'
import { MdCalendarToday } from 'react-icons/md'

import FirestoreUser, {
  isDocumentDeleted,
} from '../../../../types/FirestoreUser'
import { formatDateString } from '../../../../utils/formatDate'

interface Props {
  profile: FirestoreUser['profile']
  onDeleteDocument: (index: number) => void
}

export function DiagnosisDocumentList({ profile, onDeleteDocument }: Props) {
  return (
    <Stack spacing={0}>
      <HStack spacing={2} align='center'>
        <Icon as={FiPaperclip} color='gray.600' />
        <Text>Uploaded Documents:</Text>
        {profile?.diagnosisDateVerified && (
          <Icon as={MdCalendarToday} color='green.600' />
        )}
      </HStack>

      {profile?.diagnosisDocumentation?.map((doc, index) => {
        if (isDocumentDeleted(doc)) return null

        const url = typeof doc === 'string' ? doc : doc.url
        const uploadedAt =
          typeof doc === 'object' && 'uploadedAt' in doc
            ? doc.uploadedAt
            : undefined

        return (
          <Flex key={url} alignItems='center' gap={2}>
            <Tooltip label='Delete document' hasArrow placement='top'>
              <IconButton
                aria-label='Delete diagnosis document'
                icon={<SmallCloseIcon />}
                size='xs'
                colorScheme='red'
                variant='ghost'
                onClick={() => onDeleteDocument(index)}
              />
            </Tooltip>
            <Link color='purple.600' href={url} isExternal>
              Diagnosis Document #{index + 1}
            </Link>
            {uploadedAt && (
              <Text fontSize='xs' color='gray.500'>
                Uploaded: {new Date(uploadedAt).toLocaleDateString()}
              </Text>
            )}
            {profile.diagnosisVerified && profile.diagnosisVerificationDate && (
              <Text fontSize='sm' color='green.600'>
                Verified {formatDateString(profile.diagnosisVerificationDate)}
                {profile.diagnosisVerifiedBy &&
                  ` (${profile.diagnosisVerifiedBy})`}
              </Text>
            )}
          </Flex>
        )
      })}
    </Stack>
  )
}
